import { render, staticRenderFns } from "./CustomerPricingFormDialog.vue?vue&type=template&id=4540b4e7&"
import script from "./CustomerPricingFormDialog.vue?vue&type=script&lang=ts&"
export * from "./CustomerPricingFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports